// Home Page for Portfolio
// Home Section ->
//  Dustin Graham
//  Software Engineer
//  Bio
//  Contact Me Button

import React from 'react';
import HeroSection from '../Components/HeroSection/HeroSection';
import AboutMeSection from '../Components/AboutMeSection/AboutMeSection';
import ProjectsSection from '../Components/ProjectsSection/ProjectsSection';
import TimelineSection from '../Components/TimelineSection/TimelineSection';
import ContactSection from '../Components/ContactSection/ContactSection';

const HomePage = () => {
    return (
        <div>
            <HeroSection />
            <TimelineSection />
            <ProjectsSection />
            <AboutMeSection />
            <ContactSection />
        </div>
    )
}

export default HomePage